import { component } from 'picoapp';
import Ready from '../../js/utils/ready';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const largeText = node.querySelector('.js-largeText');
  const list = node.querySelector('.js-list');

  /**
   * Functions
   */
  const initLargeText = () => {
    if (largeText) {
      ctx.on('window:scroll', () => {
        const rect = largeText.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight * 0.85;

        if (isVisible) {
          largeText.classList.add('feature-elements__large-text--visible');
        }
      });
    }
  };

  const initList = () => {
    if (list) {
      ctx.on('window:scroll', () => {
        const rect = list.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight * 0.65;
        const bottomVisible = rect.bottom <= window.innerHeight;

        if (isVisible) {
          list.classList.add('feature-elements__list--visible');

          if (largeText) {
            largeText.classList.add('feature-elements__large-text--faded');
          }
        }

        if (bottomVisible && largeText) {
          largeText.classList.add('feature-elements__large-text--hidden');
        }
      });
    }
  };

  const init = () => {
    Ready(() => {
      initLargeText();
      initList();
      window.dispatchEvent(new Event('scroll'));
    });
  };

  /**
   * Init
   */
  init();
});
